export default function (colleagues) {
  return colleagues.map(({ id, email_address, name }) => {
    return {
      colleagueUuid: id,
      emailAddress: email_address,
      description: name,
    };
  });
}
